module.exports = __webpack_public_path__ + "static/media/x-circle.685bee34.svg";